import { TVisitRequest } from 'components/menu/VisitRequest';
import { create } from 'zustand';

interface VisitRequestStore {
  hasVisitRequest: boolean;
  visitRequest: TVisitRequest;
  initVisitRequest: () => void;
  setVisitRequest: (visitRequest: TVisitRequest) => void; // 전체 업데이트 함수 추가
}

const initialState: TVisitRequest = {
  businessPlaceId: 0,
  managerId: 0,
  managerEmail: '',
  visitors: []
};

export const useVisitRequestStore = create<VisitRequestStore>((set) => ({
  hasVisitRequest: false,
  visitRequest: initialState,
  initVisitRequest: () => {
    set(() => ({
      hasVisitRequest: false,
      visitRequest: initialState
    }))
  },
  setVisitRequest: (visitRequest) =>
    set(() => ({
      hasVisitRequest: true,
      visitRequest: visitRequest // 통째로 새로운 배열로 변경
    }))
}));
